import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../modules/commons/Button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import {HttpStatus, Status} from "../../common/Constants";
import {flattenFormGroupObject, getValueFromDDL} from "../../common/mapper";
import {formGroup} from "./config";
import MasterKasFilter from "./masterKasFilter";
import MasterKasModifying from "./masterKasModifying";
import MasterKasTable from "./masterKasTable";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../Services/Utils";
import SimpleAlert from "../../../modules/popup/SimpleAlert";

class MasterKas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterVisible: false,
            modifyingVisible: false,
            namaKas: null,
            loading: false,
            submittedFilterData: {},
            filterData: {},
            selectedData: null,
            isFetch: false,
            limit: 5,
            page: 1,
            totalData: 0,
            dataTable: [],
            alertCannotDelete: false,
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    };

    componentDidUpdate = async (_, prevState) => {
        if (
            (prevState.page !== this.state.page
                || prevState.limit !== this.state.limit) &&
            !this.state.isFetch
        ) {
            this.handleTriggerLoading();
            await this.fetchData(this.state.submittedFilterData, this.state.page, this.state.limit);
            this.handleTriggerLoading();
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevState) => ({...prevState, loading: !prevState.loading}));
    };

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevState) => ({...prevState, isFetch: true, totalData: 0}));
        let response = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getAllMasterKas,
            {paramFilters: filter, page, limit,}
        );
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            await this.setState((prevValue) => ({
                ...prevValue,
                dataTable: response.data.data,
                totalData: response.data.totalData,
                page,
                limit,
            }));
        }
        this.setState((prevState) => ({...prevState, isFetch: false}));
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleModifyingVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: null,
            modifyingVisible: !prevValue.modifyingVisible,
        }));
    };

    handleSubmitFilter = async () => {
        this.handleTriggerLoading();
        this.handleKasNameChange("namaKas", null);
        const requestBody = {
            ...this.state.filterData,
            ...this.getAllDDLValue(this.state.filterData),
        };
        await this.fetchData(requestBody, 1,this.state.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: requestBody,
            filterVisible: !prevValue.filterVisible,
        }));
        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            kodeCabang: getValueFromDDL(formGroup, "kodeCabang"),
        };
        let api;
        if (!R.isNil(this.state.selectedData)) {
            api = Api.create("NAGAMAS_MASTER_DATA").updateMasterKas;
        } else {
            api = Api.create("NAGAMAS_MASTER_DATA").createMasterKas;
        }
        let res = await this.callApi(api, requestBody);
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            this.handleModifyingVisibility();
            await this.fetchData(this.state.submittedFilterData, this.state.page, this.state.limit);
        }
        this.handleTriggerLoading();
    };

    handleShowAlertCannotDelete = () => {
        this.setState((prevValue) => ({...prevValue, alertCannotDelete: !prevValue.alertCannotDelete}));
    };

    handleDelete = async (kodeKas) => {
        this.handleTriggerLoading();
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").deleteMasterKas,
            kodeKas,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            await this.fetchData(this.state.submittedFilterData, this.state.page, this.state.limit);
        }
        if (res.data.code === 509) {
            this.handleShowAlertCannotDelete();
        }
        this.handleTriggerLoading();
    };

    handleClearFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {},
        }));
    };

    handleKasNameChange = (name, value) => {
        this.setState((prevValue) => ({...prevValue, [name]: value}));
    };

    handleSearch = async () => {
        this.handleTriggerLoading();
        this.handleClearFilter();
        await this.fetchData({name: this.state.namaKas}, 1, this.state.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: {name: this.state.namaKas},
        }));
        this.handleTriggerLoading();
    };

    handleChangeStatus = async (value, index) => {
        this.handleTriggerLoading();
        const selectedData = this.state.dataTable[index];
        const requestBody = {
            kodeKas: selectedData.kodeKas,
            kodeCabang: selectedData.kodeCabang,
            name: selectedData.name,
            status: !value ? Status.ACTIVE : Status.INACTIVE,
        };
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").updateMasterKas,
            requestBody,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            await this.fetchData(this.state.submittedFilterData, this.state.page, this.state.limit);
        }
        this.handleTriggerLoading();
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    getAllDDLValue = (data) => {
        if (!R.isNil(data)) {
            return {
                kodeCabang: data?.kodeCabang?.value,
                status: data?.status?.value,
            };
        }

        return {};
    };

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Kas",
            setError: this.props.setError,
            args: args,
        })
    };

    handleResetAllFilters = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: {},
            namaKas: null,
            submittedFilterData: {},
        }));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between", alignItems: "center"}}
                        className="margin-bottom-20px margin-top-5px"
                    >
                        <FlexView vAlignContent="center">
                            <SimpleInput
                                id="input_text_nama_kas"
                                placeholder="Nama Kas"
                                name="namaKas"
                                containerclassname="margin-bottom-5px"
                                value={this.state.namaKas}
                                onChange={({target}) => this.handleKasNameChange(target.name, target.value)}
                            />
                            <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
                        </FlexView>
                        <Button
                            type="button"
                            className="btn background-red"
                            onClick={this.handleFilterVisibility}
                        >
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
                        </Button>
                    </FlexView>
                    <MasterKasTable
                        callApi={this.callApi}
                        state={this.state}
                        onToggleChange={this.handleChangeStatus}
                        onSetState={this.handleStateChange}
                        onDelete={this.handleDelete}
                    />
                </Container>
                {this.state.filterVisible && (
                    <MasterKasFilter
                        state={this.state}
                        onClickClose={this.handleFilterVisibility}
                        onSetState={this.handleStateChange}
                        onSubmit={this.handleSubmitFilter}
                        onReset={this.handleClearFilter}
                    />
                )}
                {this.state.modifyingVisible && (
                    <MasterKasModifying
                        {...this.props}
                        formGroup={formGroup}
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onClickClose={this.handleModifyingVisibility}
                        onSubmit={this.handleSubmitModifying}
                    />
                )}
                {this.state.alertCannotDelete && (
                  <SimpleAlert
                    visible={this.state.alertCannotDelete}
                    onClickClose={() => this.handleShowAlertCannotDelete()}
                    content={
                        <div>
                            <p>Data tidak dapat dihapus, sudah masuk kedalam transaksi.</p>
                        </div>
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <SimpleButton onClick={() => this.handleShowAlertCannotDelete()}>
                                OK
                            </SimpleButton>
                        </FlexView>
                    }/>
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterKas);
